import { useEffect } from 'react'

import { useFluentToast, registerGlobalToast } from '../utils/fluentToast'

/**
 * Bridges the Fluent toast context to the imperative global API.
 * Must be rendered inside FluentToastProvider.
 */
export function ToastBridge() {
  const toast = useFluentToast()

  useEffect(() => {
    registerGlobalToast(toast)
  }, [toast])

  return null
}
